import { render, staticRenderFns } from "./EditPlayer.vue?vue&type=template&id=e5bc7ba2&"
import script from "./EditPlayer.vue?vue&type=script&lang=ts&"
export * from "./EditPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports